
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hekMp", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $c045e52c385e15eb$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $c045e52c385e15eb$var$onFavoriteButtonContainerClick = (evt, window1)=>{
    // Choose either the event's target node or offsetParent. For Favorite Button, the target node
    // could either be the star, inner space around star, or the border of the bounding box
    const node = evt?.target;
    const offsetParent = evt?.target?.offsetParent;
    if (!node && !offsetParent) return;
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    const elementId = node?.getAttribute('data-id');
    const offsetParentId = offsetParent?.getAttribute('data-id');
    const dataId = elementId || offsetParentId;
    // optimistic UI update: one user click is captured - subsequent SSR clicks not handled
    if (Boolean(window1.__SSR_EVENTS_CAPTURE__.favoriteButton)) return;
    const FILLED_COLOR = '#FFAB00'; // yellow
    const UNFILLED_COLOR = '#42526E'; // grey
    try {
        window1.__SSR_EVENTS_CAPTURE__.favoriteButton = evt;
        // Depending on user click, offsetParent could be the bounding button if
        // the inner star/white space span is clicked. To avoid querying the DOM again,
        // both nodes are checked
        const targetNode = offsetParentId === dataId ? offsetParent : node;
        const isStarred = Boolean(dataId === 'page-unstar-button');
        const svg = targetNode.querySelector('svg > path');
        // Update css
        svg.setAttribute('fill', `${isStarred ? UNFILLED_COLOR : FILLED_COLOR}`);
        svg.setAttribute('d', isStarred ? 'M12 16.373l3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655L12 16.373zm0 2.283l-3.016 1.662a2 2 0 01-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 011.129-3.377l3.47-.528 1.518-3.224a2 2 0 013.618 0l1.519 3.224 3.47.528a2 2 0 011.127 3.377l-2.569 2.624.599 3.656a2 2 0 01-2.94 2.075L12 18.656z' : 'M12.072 17.284l-3.905 2.053a1 1 0 01-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 01.554-1.705l4.366-.635 1.953-3.956a1 1 0 011.794 0l1.952 3.956 4.366.635a1 1 0 01.555 1.705l-3.16 3.08.746 4.349a1 1 0 01-1.45 1.054l-3.906-2.053z');
        return;
    } catch (e) {
        (0, $jxrZO.captureSSRScriptErrors)(dataId, e);
    }
};
const $c045e52c385e15eb$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    // only add event click handlers if the SSR feature flag is enabled
    const pageUnstarButton = document1?.querySelector("[data-id='page-unstar-button']");
    const pageStarButton = document1?.querySelector("[data-id='page-star-button']");
    const favoriteButton = pageUnstarButton || pageStarButton;
    favoriteButton?.addEventListener('click', function(evt) {
        $c045e52c385e15eb$var$onFavoriteButtonContainerClick(evt, window1);
    }, true);
};
$c045e52c385e15eb$export$4318b8b1b37d5113(document, window);

});
parcelRegister("jxrZO", function(module, exports) {

$parcel$export(module.exports, "captureSSRScriptErrors", () => $7f175c2310653115$export$cb93ee3b8e8bf836);
const $7f175c2310653115$export$cb93ee3b8e8bf836 = (scope, error)=>{
    if (!window.__SSR_CLIENT_ERRORS__) window.__SSR_CLIENT_ERRORS__ = {};
    // capturing multiple errors in SSR for the same scope
    if (window.__SSR_CLIENT_ERRORS__[scope]) window.__SSR_CLIENT_ERRORS__[scope].push(error);
    else window.__SSR_CLIENT_ERRORS__[scope] = [
        error
    ];
};

});


parcelRegister("b5bLd", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $8b4789272cefc575$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $8b4789272cefc575$var$onRestrictionsButtonContainerClick = (evt, document1, window1)=>{
    // Choose either the event's target node or offsetParent. For Restrictions Button, the target node
    // could either be the lock icon, inner space around lock icon, or the border of the bounding box
    const node = evt?.target;
    const offsetParent = evt?.target?.offsetParent;
    if (!node && !offsetParent) return;
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    const elementId = node?.getAttribute('data-id');
    const offsetParentId = offsetParent?.getAttribute('data-id');
    const dataId = elementId || offsetParentId;
    try {
        const restrictionsButton = offsetParentId === dataId ? offsetParent : node;
        if (restrictionsButton?.disabled) return;
        window1.__SSR_EVENTS_CAPTURE__.restrictionsButton = evt;
        // spinner logic
        const spinner = document1.querySelector('[data-id="restrictions-loading-spinner"]');
        if (spinner) {
            spinner.style.display = 'flex';
            spinner.style.fontSize = '14px';
        }
        if (restrictionsButton) restrictionsButton.style.display = 'none';
        return;
    } catch (e) {
        // eslint-disable-next-line no-console
        (0, $jxrZO.captureSSRScriptErrors)(dataId, e);
    }
    return;
};
const $8b4789272cefc575$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    // only add event click handlers if the SSR feature flag is enabled
    const restrictionsButton = document1?.querySelector("[data-id='restrictions-button']");
    restrictionsButton?.addEventListener('click', function(evt) {
        $8b4789272cefc575$var$onRestrictionsButtonContainerClick(evt, document1, window1);
    }, true);
};
$8b4789272cefc575$export$4318b8b1b37d5113(document, window);

});

parcelRegister("iWFnc", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $dcadbca16bd181b0$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $dcadbca16bd181b0$var$onWatchButtonContainerClick = (evt, document1, window1)=>{
    // Choose either the event's target node or offsetParent. For Watch Button, the target node
    // could either be the eye icon, inner space around eye icon, or the border of the bounding box
    const node = evt?.target;
    const offsetParent = evt?.target?.offsetParent;
    if (!node && !offsetParent) return;
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    const elementId = node?.getAttribute('data-id');
    const offsetParentId = offsetParent?.getAttribute('data-id');
    const dataId = elementId || offsetParentId;
    try {
        const watchButton = offsetParentId === dataId ? offsetParent : node;
        window1.__SSR_EVENTS_CAPTURE__.watchButton = evt;
        // spinner logic
        const spinner = document1.querySelector('[data-id="watch-loading-spinner"]');
        if (spinner) {
            spinner.style.display = 'flex';
            spinner.style.fontSize = '14px';
        }
        if (watchButton) watchButton.style.display = 'none';
        return;
    } catch (e) {
        // eslint-disable-next-line no-console
        (0, $jxrZO.captureSSRScriptErrors)(dataId, e);
    }
    return;
};
const $dcadbca16bd181b0$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    // only add event click handlers if the SSR feature flag is enabled
    const watchButton = document1?.querySelector("[data-id='page-watch-button']");
    watchButton?.addEventListener('click', function(evt) {
        $dcadbca16bd181b0$var$onWatchButtonContainerClick(evt, document1, window1);
    }, true);
};
$dcadbca16bd181b0$export$4318b8b1b37d5113(document, window);

});

parcelRegister("bNhFa", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $9691983ca2fad24d$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $9691983ca2fad24d$var$onMoreActionButtonContainerClick = (evt, window1, document1)=>{
    const node = evt?.target;
    const offsetParent = evt?.target?.offsetParent;
    if (!node && !offsetParent) return;
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    const elementId = node?.getAttribute('data-id');
    const offsetParentId = offsetParent?.getAttribute('data-id');
    const dataId = elementId || offsetParentId;
    try {
        const moreActionButton = offsetParentId === dataId ? offsetParent : node;
        window1.__SSR_EVENTS_CAPTURE__.moreActionButton = evt;
        // spinner logic
        const spinner = document1.querySelector('[data-id="more-action-loading-spinner"]');
        const moreActionButtonContainer = document1.querySelector('[data-id="content-tools-dropdown-menu-container"]');
        if (spinner) {
            spinner.style.display = 'flex';
            spinner.style.fontSize = '14px';
            spinner.style.marginLeft = '10px';
        }
        if (moreActionButton) {
            moreActionButton.style.display = 'none';
            moreActionButtonContainer.style.display = 'none';
        }
        return;
    } catch (e) {
        (0, $jxrZO.captureSSRScriptErrors)(dataId, e);
    }
};
const $9691983ca2fad24d$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    // only add event click handlers if the SSR feature flag is enabled
    const actionButtonContainer = document1?.querySelector("[data-id='page-more-action-button']");
    actionButtonContainer?.addEventListener('click', function(evt) {
        $9691983ca2fad24d$var$onMoreActionButtonContainerClick(evt, window1, document1);
    }, true);
};
$9691983ca2fad24d$export$4318b8b1b37d5113(document, window);

});

parcelRegister("2JV69", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $7b3618419874d652$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $7b3618419874d652$var$onCommentButtonClick = (evt, window1, document1)=>{
    // Choose either the event's target node or offsetParent. The target node
    // could either be the star, inner space around star, or the border of the bounding box
    const node = evt?.target;
    const offsetParent = evt?.target?.offsetParent;
    if (!node && !offsetParent) return;
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    const elementId = node?.getAttribute('data-id');
    const offsetParentId = offsetParent?.getAttribute('data-id');
    const dataId = elementId || offsetParentId;
    try {
        const inlineCommentButton = offsetParentId === dataId ? offsetParent : node;
        window1.__SSR_EVENTS_CAPTURE__.inlineCommentButton = evt;
        // spinner logic
        const spinner = document1.querySelector('[data-id="inline-comment-loading-spinner"]');
        if (spinner) {
            spinner.style.display = 'flex';
            spinner.style.fontSize = '14px';
        }
        if (inlineCommentButton) inlineCommentButton.style.display = 'none';
        return;
    } catch (e) {
        (0, $jxrZO.captureSSRScriptErrors)(dataId, e);
    }
};
const $7b3618419874d652$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    const commentButton = document1?.querySelector("[data-id='comment-button-placeholder']");
    commentButton?.addEventListener('click', function(evt) {
        $7b3618419874d652$var$onCommentButtonClick(evt, window1, document1);
    }, true);
};
$7b3618419874d652$export$4318b8b1b37d5113(document, window);

});

parcelRegister("hTwRs", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $474707012c06d1a4$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $474707012c06d1a4$var$onSpaceStarTextButtonClick = (evt, window1, document1)=>{
    // Select button wrapper by data id
    const button = document1?.querySelector("[data-testid='space-star-text-button']");
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    const elementId = button?.getAttribute('data-id');
    try {
        // Attach event to window
        window1.__SSR_EVENTS_CAPTURE__.spaceStarTextButton = evt;
        const spinner = document1.querySelector('[data-id="space-star-text-loading-spinner"]');
        if (spinner) {
            // Imitate button styles in spinner
            spinner.style.display = 'flex';
            spinner.style.width = `${button.clientWidth}px`;
            spinner.style.marginLeft = '15px';
            spinner.style.borderRadius = '3px';
        }
        // Hide button
        button.style.display = 'none';
    } catch (e) {
        (0, $jxrZO.captureSSRScriptErrors)(elementId ?? '', e);
    }
};
const $474707012c06d1a4$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    const spaceStarTextButton = document1?.querySelector("[data-testid='space-star-text-button']");
    spaceStarTextButton?.addEventListener('click', function(evt) {
        $474707012c06d1a4$var$onSpaceStarTextButtonClick(evt, window1, document1);
    }, true);
};
$474707012c06d1a4$export$4318b8b1b37d5113(document, window);

});

parcelRegister("cfnOC", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_BYLINE", () => $9f91c9896b70f4fe$export$c1822ca48c7f924b);
$parcel$export(module.exports, "TEST_ID_DIALOG_SKELETON", () => $9f91c9896b70f4fe$export$b1568f4c0bd435a7);
$parcel$export(module.exports, "addSSREventListeners", () => $9f91c9896b70f4fe$export$be4c46d3a4a72504);

var $jS7pv = parcelRequire("jS7pv");

var $aXes4 = parcelRequire("aXes4");
const $9f91c9896b70f4fe$export$c1822ca48c7f924b = 'analytics-byline';
const $9f91c9896b70f4fe$export$b1568f4c0bd435a7 = 'analytics-dialog-skeleton';
const $9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY = 'analyticsByLine';
const $9f91c9896b70f4fe$var$initSsrEvents = ()=>{
    if (!window.__SSR_EVENTS_CAPTURE__) window.__SSR_EVENTS_CAPTURE__ = {};
    if (!window.__SSR_EVENTS_CAPTURE__?.[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY]) window.__SSR_EVENTS_CAPTURE__[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY] = {};
};
const $9f91c9896b70f4fe$var$onByLineEvent = (eventType, event)=>{
    $9f91c9896b70f4fe$var$initSsrEvents();
    if (window && window.__SSR_EVENTS_CAPTURE__ && !window.__SSR_EVENTS_CAPTURE__?.[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY]) window.__SSR_EVENTS_CAPTURE__[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY][eventType] = event;
    return;
};
const $9f91c9896b70f4fe$var$onByLineClick = (bylineElem, dialogElem, event)=>{
    $9f91c9896b70f4fe$var$initSsrEvents();
    if (window && window.__SSR_EVENTS_CAPTURE__ && !window.__SSR_EVENTS_CAPTURE__?.[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY]?.[(0, $aXes4.SSREvent).CLICK]) {
        dialogElem.style.display = 'block';
        // Based on byline position center the dialog skeleton
        const dialogWidth = dialogElem.getBoundingClientRect().width;
        const byLineWidth = bylineElem.getBoundingClientRect().width;
        const dialogLeftOffset = bylineElem.offsetLeft + byLineWidth / 2 - dialogWidth / 2;
        dialogElem.style.left = `${dialogLeftOffset}px`;
        window.__SSR_EVENTS_CAPTURE__[$9f91c9896b70f4fe$var$SSR_EVENTS_CAPTURE_KEY][(0, $aXes4.SSREvent).CLICK] = event;
        window.performance.mark((0, $jS7pv.CLICKED_BYLINE_SSR_MARK));
    }
    return;
};
const $9f91c9896b70f4fe$export$be4c46d3a4a72504 = ()=>{
    const byline = document?.querySelector(`[data-testid="${$9f91c9896b70f4fe$export$c1822ca48c7f924b}"]`);
    const dialog = document?.querySelector(`[data-testid="${$9f91c9896b70f4fe$export$b1568f4c0bd435a7}"]`);
    if (!byline || !dialog) return;
    byline?.addEventListener('click', function(evt) {
        $9f91c9896b70f4fe$var$initSsrEvents();
        $9f91c9896b70f4fe$var$onByLineClick(byline, dialog, evt);
    }, true);
    byline?.addEventListener('hover', function(evt) {
        $9f91c9896b70f4fe$var$initSsrEvents();
        $9f91c9896b70f4fe$var$onByLineEvent((0, $aXes4.SSREvent).HOVER, evt);
    }, true);
    byline?.addEventListener('focus', function(evt) {
        $9f91c9896b70f4fe$var$initSsrEvents();
        $9f91c9896b70f4fe$var$onByLineEvent((0, $aXes4.SSREvent).FOCUS, evt);
    }, true);
};
$9f91c9896b70f4fe$export$be4c46d3a4a72504();

});
parcelRegister("jS7pv", function(module, exports) {

$parcel$export(module.exports, "TestId", () => $d3258a672d0895b9$export$f067415f668a97e9);
$parcel$export(module.exports, "SSR_EVENTS_CAPTURE_KEY", () => $d3258a672d0895b9$export$f79f9d6fd24cf942);
$parcel$export(module.exports, "CLICKED_BYLINE_SSR_MARK", () => $d3258a672d0895b9$export$5ac4ec80482fdf4b);
var $d3258a672d0895b9$export$f067415f668a97e9 = /*#__PURE__*/ function(TestId) {
    // CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
    TestId["BYLINE"] = "analytics-byline";
    return TestId;
}({});
const $d3258a672d0895b9$export$f79f9d6fd24cf942 = 'analyticsByLine';
const $d3258a672d0895b9$export$5ac4ec80482fdf4b = 'clicked-analytics-byline-fmp-ssr.rendered';

});

parcelRegister("aXes4", function(module, exports) {

$parcel$export(module.exports, "SSREvent", () => $4de63777257ade50$export$64176d052f399149);
var $4de63777257ade50$export$64176d052f399149 = /*#__PURE__*/ function(SSREvent) {
    SSREvent["CLICK"] = "click";
    SSREvent["HOVER"] = "hover";
    SSREvent["FOCUS"] = "focus";
    return SSREvent;
}({});

});


parcelRegister("8Oxny", function(module, exports) {

$parcel$export(module.exports, "addSSRClickListeners", () => $100cbce192263f6e$export$4318b8b1b37d5113);
const $100cbce192263f6e$export$4318b8b1b37d5113 = (document1, window1)=>{
    /*Copied from next/packages/comment/src/utils.ts*/ const FABRIC_PAGE_MARKER_REF_ATTRIBUTE = 'data-id';
    const TINY_PAGE_MARKER_REF_ATTRIBUTE = 'data-ref';
    const getHighlightFromMarkerRef = (markerRef, additionalQueryScope = '')=>{
        if (!markerRef) return null;
        // We need to allow for additional query scope to be added to specify particular markerRef comments
        return document1.querySelector(`${additionalQueryScope} [${FABRIC_PAGE_MARKER_REF_ATTRIBUTE}="${markerRef}"], ${additionalQueryScope} [${TINY_PAGE_MARKER_REF_ATTRIBUTE}="${markerRef}"]`);
    };
    const adjustNodeForStickyHeader = (stickyHeaderElement)=>{
        let adjustedElement = stickyHeaderElement;
        const markerRef = getMarkerRef(adjustedElement);
        // If this is exists it's a commited comment, look for its counterpart in the real table
        // TODO: Support new highlights when we allow it
        if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
        adjustedElement = getHighlightFromMarkerRef(markerRef, '.pm-table-wrapper');
        return adjustedElement;
    };
    // Function to calculate a comment's offset taking nested elements into consideration
    const calculateElementOffset = (element, isFabricHighlight)=>{
        let elementOffsetTop = 0;
        let nodeToMeasure = element;
        // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
        // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
        if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) nodeToMeasure = adjustNodeForStickyHeader(nodeToMeasure);
        // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
        // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
        // pages do not have anything like that, but will return null when we get to <body>
        while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper')){
            elementOffsetTop += nodeToMeasure.offsetTop;
            nodeToMeasure = nodeToMeasure.offsetParent;
        }
        if (isFabricHighlight === undefined) return elementOffsetTop;
        else if (isFabricHighlight) {
            const rendererWrapper = document1.querySelector('#content .ak-renderer-wrapper');
            if (rendererWrapper) elementOffsetTop += rendererWrapper.offsetTop;
        } else {
            const pageMetadata = document1.querySelector('#content-body .page-metadata-modification-info');
            if (pageMetadata) elementOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
        }
        return elementOffsetTop;
    };
    const getMarkerRef = (element)=>{
        let markerRef = null;
        if (element) {
            markerRef = element.getAttribute(FABRIC_PAGE_MARKER_REF_ATTRIBUTE);
            if (!markerRef) markerRef = element.getAttribute(TINY_PAGE_MARKER_REF_ATTRIBUTE);
        }
        return markerRef;
    };
    // Function to scroll a comment into view with the correct offsets
    const scrollCommentIntoViewAndFetchOffset = (commentElement, isFabricPage)=>{
        if (!commentElement) return;
        // We may be in an iframe so use window.top
        const currentWindowHeight = window1.innerHeight || window1?.top?.innerHeight;
        const currentPageOffset = window1.scrollY || window1?.top?.scrollY;
        const offset = calculateElementOffset(commentElement) + commentElement.offsetHeight;
        const rendererOffset = document1.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // Stop scrollTo being set if window doesn't provide all the needed info
        if (typeof currentWindowHeight !== 'number' || typeof currentPageOffset !== 'number') return;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            window1.scrollTo({
                top: offset - windowOffset
            });
            return offset - windowOffset;
        }
    };
    const bindSSREventMouseEventHandlers = (target)=>{
        if (!target) return;
        const onClick = (evt)=>{
            if (!window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__) window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ = {};
            const isFabricHighlight = evt.target?.dataset?.markAnnotationType === 'inlineComment';
            const isTinyHighlight = evt.target?.classList?.contains('inline-comment-marker');
            if (isFabricHighlight || isTinyHighlight) {
                if (!window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements']) {
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] = [];
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] = '';
                }
                // Grab offset for InlineCommentsLoadingSkeleton placement
                let markOffsetTop = 0;
                const inlineHighlight = evt.target;
                try {
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].push(inlineHighlight);
                    markOffsetTop = calculateElementOffset(inlineHighlight, Boolean(isFabricHighlight));
                    // Save position for loading state skeletons
                    window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] = markOffsetTop;
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
                // Select sidebar skeleton and show it during ssr
                const sidebar = document1.getElementById('inline-comment-sidebar-skeleton');
                if (sidebar) {
                    sidebar.style.display = 'block';
                    sidebar.style.top = `${markOffsetTop}px`;
                    inlineHighlight.classList.add('active-highlight');
                }
            }
        };
        target.addEventListener('click', onClick, true);
    };
    /* Gets Sorted MarkerRefs in DOM and filters ones returned by back-end API for Unresolved comments */ const getSortedMarkerRefs = (markerRefList, rawMarks)=>{
        const marksArray = Array.from(rawMarks).map((node)=>getMarkerRef(node));
        /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
        duplicates in that case so we can navigate between comments correctly */ const distinctMarks = [
            ...new Set(marksArray)
        ];
        return distinctMarks.filter((mark)=>markerRefList.includes(mark));
    };
    const getFocusedMarkIndex = (markerRefs, focusedMarkerRef)=>{
        const focusedMarkPosition = markerRefs.findIndex((mark)=>mark === focusedMarkerRef);
        return focusedMarkPosition || 0;
    };
    const addFocusedInlineComment = (focusedMarkerRef, markerRefs, marks)=>{
        if (!window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__) {
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ = {};
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] = {};
        }
        const focusedElement = document1.querySelector(`[${FABRIC_PAGE_MARKER_REF_ATTRIBUTE}="${focusedMarkerRef}"]`);
        // If we cannot query for correct focused element we want to exit
        if (!focusedElement) return;
        const sortedMarks = getSortedMarkerRefs(markerRefs, marks);
        const totalHighlights = sortedMarks.length;
        const isFabricHighlight = focusedElement?.dataset?.markAnnotationType === 'inlineComment';
        const isTinyHighlight = focusedElement?.classList?.contains('inline-comment-marker');
        if (isFabricHighlight || isTinyHighlight) {
            const markOffsetTop = calculateElementOffset(focusedElement, Boolean(isFabricHighlight));
            const commentPosition = getFocusedMarkIndex(sortedMarks, focusedMarkerRef);
            const isFabricPage = !!isFabricHighlight;
            const scrollToOffset = scrollCommentIntoViewAndFetchOffset(focusedElement, isFabricPage);
            // Set window values for SPA to read
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'] = markOffsetTop;
            // Set scroll value for page scroll if focusedComment is lower than top
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'] = scrollToOffset;
            // Setting window values from data added to dom in addInlineHighlights
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position'] = commentPosition;
            //Set total Comments
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments'] = totalHighlights;
            window1.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRef'] = focusedMarkerRef;
            // Select sidebar skeleton and show it during ssr
            const sidebar = document1.getElementById('focused-inline-comment-sidebar-skeleton');
            // Prevent browser from moving the scroll position around on page load
            if (history) history.scrollRestoration = 'manual';
            /* if markOffsetTop is 0 dont render */ if (sidebar && markOffsetTop) {
                sidebar.style.top = `${markOffsetTop}px`;
                sidebar.style.display = 'block';
                focusedElement.classList.add('active-highlight');
                // Set inline comment number
                const inlineCommentNumberContainer = sidebar.querySelector('#inline-comment-index');
                if (inlineCommentNumberContainer && typeof commentPosition === 'number' && typeof totalHighlights === 'number') inlineCommentNumberContainer.textContent = `${commentPosition + 1} of ${totalHighlights}`;
                window1.performance.mark('focused-inline-comment-fmp-ssr.rendered');
            }
        }
    };
    // Get focused marker ref from data attribute
    const focusedMarkerRef = document1.getElementById('inline-comments-script')?.getAttribute('data-focused');
    /* get markerRefs from data-mark attribute - comes in as a string
      convert to array */ const markerRefs = document1.getElementById('inline-comments-script')?.getAttribute('data-marks')?.split(',');
    if (markerRefs && Array.isArray(markerRefs) && markerRefs.length > 0) {
        const marks = document1.querySelectorAll(`.inline-comment-marker, [data-mark-annotation-type="inlineComment"]`);
        /* Handle Focused Comment SSR */ if (focusedMarkerRef) addFocusedInlineComment(focusedMarkerRef, markerRefs, marks);
        else /* Add click listeners to SSR'd inline comments - not for focused inline comment page */ Array.from(marks).forEach((el)=>{
            /* get markerRef from data-id for fabric, data-ref for tiny*/ const markerRef = el.getAttribute(FABRIC_PAGE_MARKER_REF_ATTRIBUTE) || el.getAttribute(TINY_PAGE_MARKER_REF_ATTRIBUTE);
            if (markerRef && markerRefs?.includes(markerRef)) bindSSREventMouseEventHandlers(el);
        });
    }
};
$100cbce192263f6e$export$4318b8b1b37d5113(document, window);

});

parcelRegister("kEc0e", function(module, exports) {

$parcel$export(module.exports, "onClickDismissAdminAnnouncementButtonHandler", () => $6a4dc191299c5cd6$export$52439978e83cfcfe);
$parcel$export(module.exports, "addSSRClickListeners", () => $6a4dc191299c5cd6$export$4318b8b1b37d5113);

var $jxrZO = parcelRequire("jxrZO");
const $6a4dc191299c5cd6$export$52439978e83cfcfe = (evt, document1, window1)=>{
    const dismissButton = evt?.currentTarget;
    if (!dismissButton) return;
    const dataId = dismissButton.getAttribute('data-id') || '';
    if (!window1.__SSR_EVENTS_CAPTURE__) window1.__SSR_EVENTS_CAPTURE__ = {};
    else if (Boolean(window1.__SSR_EVENTS_CAPTURE__.dismissAdminAnnouncementBannerButton)) return;
    try {
        const spinner = document1.querySelector('[data-id="dismiss-admin-announcement-banner-loading-spinner"]');
        if (spinner) {
            spinner.style.display = 'flex';
            // Disabling linting rule for this line since it applies to a spinner and we currently don't
            // have a way to just apply a fontSize, only a font attribute.
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            spinner.style.fontSize = '14px';
        }
        if (dismissButton) dismissButton.style.display = 'none';
        window1.__SSR_EVENTS_CAPTURE__.dismissAdminAnnouncementBannerButton = evt;
    } catch (e) {
        (0, $jxrZO.captureSSRScriptErrors)(dataId, e);
    }
};
const $6a4dc191299c5cd6$export$4318b8b1b37d5113 = (document1, window1)=>{
    if (window1?.__HYDRATABLE__) return;
    const dismissButton = document1?.querySelector("[data-id='ssr-dismiss-admin-announcement-button']");
    dismissButton?.addEventListener('click', function(evt) {
        $6a4dc191299c5cd6$export$52439978e83cfcfe(evt, document1, window1);
    }, true);
};
$6a4dc191299c5cd6$export$4318b8b1b37d5113(document, window);

});

parcelRegister("kHAdr", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");
const $b7aa9cbf24a2d47a$var$setAjsMetadata = ()=>{
    (0, $3d5UI.waitForGlobal)({
        listener: 'ssrLegacyBridge',
        globalProperty: 'AJS.Meta.set',
        interval: 50
    }, ()=>{
        const ajsMetaParamsStr = window.__SSR_AJS_META__;
        let ajsMetaParams = [];
        try {
            ajsMetaParams = JSON.parse(ajsMetaParamsStr);
        } catch (error) {
        /* NOOP */ }
        // We have 2 legacy bridge here based on graphql
        // Another in packages/confluence-frontend-server/src/components/LegacyBridge/LegacyBridge.js
        // based on Redux. We need to let the legacy one know we have already dealt with these meta
        // tags don't override.
        if (ajsMetaParams?.length > 0) {
            window.AJS.Meta.set('has-next-legacy-bridge', true);
            ajsMetaParams.forEach(({ key: key, value: value })=>{
                window.AJS.Meta.set(key, value);
                // This logic is to match the classic LegacyBridge, as apparently it was missing in
                // the LegacyBridgeNext and some macros rely on AJS.params as opposed to AJS.Meta.
                if (key === 'page-id') window.AJS.params.pageId = value;
                if (key === 'space-key') window.AJS.params.spaceKey = value;
            });
        }
    });
};
$b7aa9cbf24a2d47a$var$setAjsMetadata();

});
parcelRegister("3d5UI", function(module, exports) {

$parcel$export(module.exports, "waitForGlobal", () => $28507a73a7688e48$export$88d492d47be57a7e);
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}

});


parcelRegister("kRdFo", function(module, exports) {

$parcel$export(module.exports, "upateCoverPictureDimension", () => $3d9ba5a7bda7cf88$export$9f1e476260e32cbb);

var $dkxaU = parcelRequire("dkxaU");
const $3d9ba5a7bda7cf88$export$9f1e476260e32cbb = (document1)=>{
    // Only run script if found this element
    const enableScript = document1.querySelector('[data-id="ssr-cover-picture-dimension"]');
    if (!enableScript) return;
    const editorParent = document1.querySelector('.fabric-editor-popup-scroll-parent');
    const parentWidth = editorParent?.clientWidth || 0;
    if (!parentWidth) return;
    const coverImageWrapper = document1.querySelector('[data-id="cover-pic-and-button-wrapper"]');
    if (!coverImageWrapper) return;
    const height = (0, $dkxaU.calcDynamicCoverImageHeight)(parentWidth);
    coverImageWrapper.style.width = `${parentWidth}px`;
    coverImageWrapper.style.height = `${height}px`;
};
$3d9ba5a7bda7cf88$export$9f1e476260e32cbb(document);

});
parcelRegister("dkxaU", function(module, exports) {

$parcel$export(module.exports, "calcDynamicCoverImageHeight", () => $17b31ae3aa6020db$export$6a5c726aaec5b09);

var $75Ax4 = parcelRequire("75Ax4");
const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};

});
parcelRegister("75Ax4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_POSITION_VALUE", () => $4cdfc0aeee394c11$export$5a7e63ae23cefcb);
$parcel$export(module.exports, "REFERRAL_LINK", () => $4cdfc0aeee394c11$export$535fddacdd1506a3);
$parcel$export(module.exports, "MIN_DYNAMIC_COVER_IMAGE_HEIGHT", () => $4cdfc0aeee394c11$export$41f496cb75ebdbf4);
$parcel$export(module.exports, "MAX_DYNAMIC_COVER_IMAGE_HEIGHT", () => $4cdfc0aeee394c11$export$e1a10bbd512cde25);
$parcel$export(module.exports, "COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO", () => $4cdfc0aeee394c11$export$e63c70235aab4f60);
$parcel$export(module.exports, "COVER_IMAGE_FIXED_WIDTH", () => $4cdfc0aeee394c11$export$f94fb8385ddeea1f);
$parcel$export(module.exports, "COVER_IMAGE_FIXED_HEIGHT", () => $4cdfc0aeee394c11$export$f60e801aad1e2af5);
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$bf8e3e9ad679f178 = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;

});



// lightweight script to scan the SSR response and collect all elements with data-ssr-placeholder attribute
// and save their size/positions in a map __SSR_PLACEHOLDERS_DIMENSIONS__ on the Window object. Each placeholderId is
// unique and maps to its corresponding elements bounding client rectangle dimensions.
function $b8b2d306bbe1b8cb$export$aee7516e57289027(document, window, enablePageLayoutPlaceholder = false) {
    const ssrPlaceholders = document?.querySelectorAll('[data-ssr-placeholder]');
    ssrPlaceholders.forEach((elem)=>{
        const placeholderId = elem.getAttribute('data-ssr-placeholder');
        const boundingClient = elem.getBoundingClientRect();
        if (placeholderId) {
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__[placeholderId] = boundingClient;
        }
    });
    if (enablePageLayoutPlaceholder) {
        const pageLayoutRoot = document?.getElementById('unsafe-design-system-page-layout-root');
        if (pageLayoutRoot) {
            const boundingClient = pageLayoutRoot.getBoundingClientRect();
            window.__SSR_PLACEHOLDERS_DIMENSIONS__ = window.__SSR_PLACEHOLDERS_DIMENSIONS__ || {};
            window.__SSR_PLACEHOLDERS_DIMENSIONS__['page-layout.root'] = boundingClient;
        }
    }
}


const $6f7e28bb4a7687f7$var$dataLoadableBeginRegex = /data-loadable-begin="([^"]*)"/;
const $6f7e28bb4a7687f7$var$dataLoadableEndRegex = /data-loadable-end="([^"]*)"/;
const $6f7e28bb4a7687f7$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER = 2;
function $6f7e28bb4a7687f7$var$findEndMarker(root, loadableId) {
    if (!root) return null;
    let el = root;
    while(el = el.nextSibling){
        if (el.nodeType !== Node.COMMENT_NODE) continue;
        const match = el?.nodeValue?.match($6f7e28bb4a7687f7$var$dataLoadableEndRegex);
        if (match && match[1] === loadableId) return el;
    }
    return null;
}
function $6f7e28bb4a7687f7$export$8276aefd9449c44b(root = document.body) {
    if (!window.__SSR_RENDERED__) return;
    try {
        const nodes = root.childNodes;
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            const nodeType = node.nodeType;
            if (nodeType === Node.COMMENT_NODE) {
                const match = node.nodeValue?.match($6f7e28bb4a7687f7$var$dataLoadableBeginRegex);
                if (match) {
                    const loadableId = match[1];
                    // We found a begin marker
                    let insertionPoint = node;
                    while(insertionPoint.nextSibling)insertionPoint = insertionPoint.nextSibling;
                    if (!insertionPoint.parentNode) continue;
                    // Now let's find the end
                    let endMarker = null;
                    let beginMarker = node;
                    let moveUpLevelCount = 0;
                    while(!(endMarker = $6f7e28bb4a7687f7$var$findEndMarker(beginMarker, loadableId)) && moveUpLevelCount <= $6f7e28bb4a7687f7$var$MAX_MOVE_UP_LEVEL_FOR_BEGIN_MARKER){
                        // We can't find it, go up a level
                        if (beginMarker.parentNode) {
                            beginMarker = beginMarker.parentNode;
                            moveUpLevelCount++;
                        } else break;
                    }
                    // Now we have a pairing end. Check if they are already siblings
                    if (endMarker && endMarker.parentNode === insertionPoint.parentNode) continue;
                    // Move the nodes
                    if (endMarker && endMarker.parentNode && beginMarker.parentNode === endMarker.parentNode) {
                        let nextSibling = endMarker.nextSibling;
                        let node = endMarker;
                        while(node && node !== beginMarker){
                            const previousSibling = node.previousSibling;
                            insertionPoint.parentNode.insertBefore(node, insertionPoint.nextSibling);
                            node = previousSibling;
                        }
                        // In the case where there are inline text following the macro, we need to move these nodes as well
                        // Move all nodes up until the last dangling empty tag
                        while(nextSibling && nextSibling.nodeName !== beginMarker.nodeName){
                            const nodeToMove = nextSibling;
                            nextSibling = nextSibling.nextSibling;
                            beginMarker.appendChild(nodeToMove);
                        }
                        /**
						 * <p><span>foo<div>something</div></span>bar</p>
						 * will become
						 * <p><span>foo</span></p><div>something</div>bar<p></p>
						 * Remove the last dangling empty tag
						 */ if (nextSibling instanceof HTMLElement && nextSibling.nodeName === beginMarker.nodeName && !nextSibling.innerHTML) nextSibling.parentNode?.removeChild(nextSibling);
                    }
                }
            } else if (nodeType === Node.ELEMENT_NODE) $6f7e28bb4a7687f7$export$8276aefd9449c44b(node);
        }
    } catch (e) {}
}


// Code in this file runs after HTML body
if (window.__FIX_INLINE_MACRO_NESTED_DIV__) (0, $6f7e28bb4a7687f7$export$8276aefd9449c44b)();











if (window.__SSR_RENDERED__) {
    (0, $b8b2d306bbe1b8cb$export$aee7516e57289027)(document, window);
    (parcelRequire("hekMp"));
    (parcelRequire("b5bLd"));
    (parcelRequire("iWFnc"));
    (parcelRequire("bNhFa"));
    (parcelRequire("2JV69"));
    (parcelRequire("hTwRs"));
    (parcelRequire("cfnOC"));
    (parcelRequire("8Oxny"));
    (parcelRequire("kEc0e"));
    (parcelRequire("kHAdr"));
    (parcelRequire("kRdFo"));
}


//# sourceMappingURL=ssr-scripts-after.6666f225.js.map
